// src/app/meter/components/meter-analytics/meter-status-chart/meter-status-chart.component.ts

import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { MeterStatusItem } from '../../../models/meter-analytics.model';

@Component({
    selector: 'app-meter-status-chart',
    templateUrl: './meter-status-chart.component.html',
    styleUrls: ['./meter-status-chart.component.scss'],
})
export class MeterStatusChartComponent implements OnChanges {
    @Input() data: MeterStatusItem[] = [];

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
    };

    constructor(private translate: TranslateService) {}

    get total(): number {
        return this.data.reduce((sum, item) => sum + item.count, 0);
    }

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        this.chartData = {
            labels: this.data.map((s) => this.translate.instant(`meter.analytics.status_${s.status}`)),
            datasets: [
                {
                    data: this.data.map((s) => s.count),
                    backgroundColor: ['#10b981', '#d1d5db'],
                    borderWidth: 0,
                },
            ],
        };
    }
}
